let allowedMaxQuantity = 5;
if (thisIs_single_product_params) {
  allowedMaxQuantity = parseInt(thisIs_single_product_params.max_quantity);
}

function increaseCount() {
  var inputField = jQuery(this).siblings("input[type=number]");
  let inputValue = inputField.val();
  let maxQuantity = inputField.attr("max");
  if (!maxQuantity) {
    maxQuantity = allowedMaxQuantity;
    inputField.attr("max", maxQuantity);
  }
  inputValue = parseInt(inputValue);
  maxQuantity = parseInt(maxQuantity);

  if (!isNaN(inputValue) && inputValue !== "") {
    if (inputValue < maxQuantity) {
      inputValue = parseInt(inputValue);
      inputField.val(inputValue + 1);
    }
  } else {
    inputField.val(1);
  }
  jQuery("button[name='update_cart']").prop("disabled", false);
}

function decreaseAmount() {
  var inputField = jQuery(this).siblings("input[type=number]");
  var inputValue = parseInt(inputField.val());
  if (inputValue > 1) {
    inputField.val(inputValue - 1);
    jQuery("button[name='update_cart']").prop("disabled", false);
  }
}

function handleHiddenInput(hiddenInputs) {
  hiddenInputs.attr("type", "number");
  let plusSign = hiddenInputs.next();
  let minusSign = hiddenInputs.prev().prev();

  plusSign.off("click");
  minusSign.off("click");

  plusSign.css("opacity", 0);
  plusSign.css("cursor", "auto");
  minusSign.css("opacity", 0);
  minusSign.css("cursor", "auto");
}

function handleTermsCheckbox() {
  if (jQuery(this).is(":checked")) {
    jQuery(".btn-container a").removeClass("btn--disabled");
  } else {
    jQuery(".btn-container a").addClass("btn--disabled");
  }
}

//click handlers should be added when document is ready (ready event)
//first and then on every ajax request in the cart page (ajaxComplete event)
function applyClickHandlers(type) {
  if (type === "ajax") {
    jQuery(".plus-btn").off("click");
    jQuery(".minus-btn").off("click");
    jQuery(".plus-btn")
      .siblings("input[type=number]")
      .each(function () {
        let inputField = jQuery(this);
        inputField.on("keyup", enforceMinMax);
      });
  }

  jQuery(".plus-btn").click(increaseCount);
  jQuery(".minus-btn").click(decreaseAmount);

  //handling items that can only be added once
  let hiddenInputs = jQuery(".plus-btn").siblings("input[type=hidden]");
  if (hiddenInputs) {
    handleHiddenInput(hiddenInputs);
  }

  //enable/disable Proceed to Checkout button based on Terms and Conditions checkbox
  jQuery("#terms_conditions").on("change", handleTermsCheckbox);

  jQuery(".plus-btn")
    .siblings("input[type=number]")
    .each(function () {
      let inputField = jQuery(this);
      let maxQuantity = inputField.attr("max");

      if (!maxQuantity) {
        maxQuantity = allowedMaxQuantity;
        inputField.attr("max", maxQuantity);
      }
    });
}

function enforceMinMax(e) {
  e.preventDefault();
  let input = jQuery(this);
  let inputValue = input.val();
  let max = input.attr("max");
  let min = input.attr("min");
  if (input.value != "") {
    if (parseInt(inputValue) < parseInt(min)) {
      input.val(min);
    }
    if (parseInt(inputValue) > parseInt(max)) {
      input.val(max);
    }
    if (!max) {
      input.val(allowedMaxQuantity);
      inputField.attr("max", allowedMaxQuantity);
    }
    if (parseInt(inputValue) == 0 && min == 0) {
      input.val(1);
      input.attr("min", 1);
    }

    if (!Number.isInteger(parseFloat(inputValue))) {
      input.val(Math.round(parseFloat(inputValue)));
    }
  }
}

jQuery(window).ready(function ($) {
  jQuery(".plus-btn")
    .siblings('input[type="number"]')
    .each(function () {
      let input = jQuery(this);

      if (input.attr("max") > allowedMaxQuantity || !input.attr("max")) {
        input.attr("max", allowedMaxQuantity);
      }

      input.on("keyup", enforceMinMax);

      //prevent decimals
      input.on("keydown", function (e) {
        if (e.which === 190) {
          return false;
        }
      });

      input.on("change", function () {
        if (input.attr("max") > allowedMaxQuantity) {
          input.attr("max", allowedMaxQuantity);
        }
      });
    });
  applyClickHandlers("ready");
});

jQuery(window).ajaxComplete(function ($) {
  applyClickHandlers("ajax");
});
